import {COMPANY_PANEL} from "app/config/urls/prefixes";
const prefix = `${COMPANY_PANEL}/map`;

//pc = panel.company

export const mapRoutes = {
  'pc.map': `${prefix}`,
}
